import React from "react";
import styled from "styled-components";

const Heading = styled.h3`
  width: 100%;
  margin-top: 6px;
  margin-bottom: 0;
  padding: 4px 10px;
  color: #828282;
  background: #f2f2f2;
`;

export function TimeSheetHeading({ title }) {
  return <Heading>{title}</Heading>;
}
